import {
  getCompetitorTableHeader,
  getCompetitorUpdate,
} from '@/pages/opinion/services/competitor';
import { findGameInfo } from '@/pages/opinion/utils/game';
import moment from 'moment';
import { useEffect, useState } from 'react';

export default function useGameCompetitor({
  gameInfo,
  filter,
  requestGame = true,
  defaultSelectGame,
}: any) {
  const [mainGame, setMainGame] = useState<any>({});
  // 竞品游戏，没有相关的游戏信息。作为参数存在
  const [competitorGame, setCompetitorGame] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);
  // 选中的游戏，就不需要去查找了，全是父级游戏，不存在子级游戏
  const [originalGameList, setOriginalGameList] = useState<Array<any>>([]);
  // 包含当前游戏， 全是父级游戏，不存在子级游戏
  const [originalGameAndMainGame, setOriginalGameAndMainGame] = useState<
    Array<any>
  >([]);
  // 是否使用缓存数据
  const [isCache, setIsCache] = useState(false);

  function dealwithCompetitorGame(gamesList: any) {
    let { competitors, main } = gamesList || {};
    let { games, infos } = competitors || {};
    let competitorSelectedGames: Array<any> = [];

    let competitorGameDetailList = games?.map(
      (v: { edition_unified_id: any }) => {
        let [data, game] = findGameInfo(infos || [], v.edition_unified_id) || [
          {},
        ];
        competitorSelectedGames.push({
          ...(game || data),
          selected_edition_unified_id: v.edition_unified_id,
        });
        return {
          ...(data || {}),
          release_date:
            data?.release_time === ''
              ? data?.release_time
              : moment(data.release_time).format('YYYY-MM-DD HH:mm:ss'),
        };
      },
    );

    let [mainData] = findGameInfo([main], gameInfo.edition_unified_id) || [];
    let competitorGame = [mainData, ...(competitorGameDetailList || [])];

    setOriginalGameAndMainGame([
      { ...main, selected_edition_unified_id: gameInfo.edition_unified_id },
      ...competitorSelectedGames,
    ]);
    setOriginalGameList(competitorSelectedGames);
    setMainGame(mainData);
    setCompetitorGame(competitorGame);
  }

  useEffect(() => {
    if (defaultSelectGame) {
      dealwithCompetitorGame(defaultSelectGame);
    }
  }, []);

  /**
   * 获取竞品表头信息
   */
  const getCompetitorGames = async () => {
    setLoading(true);
    setIsCache(false);
    let result: any = await getCompetitorTableHeader({
      ...filter,
      is_only_unified_id: true,
      need_country_publisher: true,
      need_mobile_editions: true,
      need_second_country_publisher: true,
    });

    dealwithCompetitorGame(result);
    setLoading(false);
  };

  /**
   * 乐观更新表格
   * @param ids 排序数组id的顺序
   * @param handleMode SORT：排序 DELETE 删除游戏（暂时不可用）
   * @param currentIndex 当前需排序的索引
   */
  const sortAndDeleteAndUpdateCompetitorTable = async (
    games: any[],
    main: any,
    type: 'delete' | 'sort' | 'update' = 'update',
  ) => {
    games = games || [];
    const handleGames = games?.map(item => {
      const [game] = findGameInfo([item], item.selected_edition_unified_id) || [
        {},
      ];
      return game || {};
    });

    // 只要前九个
    handleGames.splice(9); 
    if (handleGames.length > -1) {
      const params = {
        ...gameInfo,
        games: (handleGames || []).map(item => {
          return {
            edition_unified_id: item.edition_unified_id,
            entity_type: item.entity_type,
            id_type: item.id_type,
            entity_name: item.entity_name,
            release_time: item.release_time,
          };
        }),
      };

      if (type === 'sort') {
        params.action = 'table_sort';
      }

      await getCompetitorUpdate(params);
    }

    setOriginalGameAndMainGame([...main, ...games]);

    // 找到主游戏相关数据
    const [game] = findGameInfo(main, main[0]?.selected_edition_unified_id) || [
      {},
    ];
    setOriginalGameList([...games]);
    setIsCache(['delete', 'sort'].includes(type));
    setCompetitorGame([game || {}, ...handleGames]);
  };

  const backupsGameList = () => {
    const backupsGames = [...originalGameAndMainGame];
    const main = backupsGames.splice(0, 1);

    return [backupsGames, main];
  };

  /**
   * 游戏排序
   * @param sortIndex
   */
  const sortCompetitorGame = (sortIndex: number) => {
    const [backupsGames, main] = backupsGameList();
    const currentGame = backupsGames[sortIndex];
    backupsGames[sortIndex] = backupsGames[sortIndex + 1];
    backupsGames[sortIndex + 1] = currentGame;
    sortAndDeleteAndUpdateCompetitorTable(backupsGames, main, 'sort');
  };

  /**
   * 游戏删除
   * @param deleteIndex
   */
  const deleteCompetitorGame = (deleteIndex: number) => {
    const [backupsGames, main] = backupsGameList();
    backupsGames.splice(deleteIndex, 1);
    sortAndDeleteAndUpdateCompetitorTable(backupsGames, main, 'delete');
  };

  // 切换游戏
  const changeCompetitorGame = (
    game: any | Array<any>,
    changeIndex?: number,
  ) => {
    const [backupsGames, main] = backupsGameList();
    // 切换为子版本的情况
    if (!Array.isArray(game)) {
      backupsGames[changeIndex as number] = game;
      sortAndDeleteAndUpdateCompetitorTable(backupsGames, main);
    } else {
      sortAndDeleteAndUpdateCompetitorTable(game, main);
    }
  };

  useEffect(() => {
    if (gameInfo && filter && requestGame) {
      getCompetitorGames();
    }
  }, [gameInfo, filter]);

  return {
    mainGame,
    competitorGame,
    getCompetitorGames,
    originalGameList,
    originalGameAndMainGame,
    sortCompetitorGame,
    deleteCompetitorGame,
    changeCompetitorGame,
    loading,
    isCache,
    setIsCache,
  };
}
